import tourDetailMain_bg from "../lastimages/tourPage/tourDetailMain_bg.jpg";
import hotelPageMain from "../lastimages/tourPage/hotelPageMain.jpg";
import hotelDetail1 from "../lastimages/tourPage/hotelDetail1.jpg";
import hotelDetail2 from "../lastimages/tourPage/hotelDetail2.jpg";
import hotelDetail3 from "../lastimages/tourPage/hotelDetail3.jpg";
import package1 from "../lastimages/tourPage/package1.jpg";
import package2 from "../lastimages/tourPage/package2.jpg";
import paris from "../lastimages/product/paris.jpg";
import prijieng from "../lastimages/product/prijieng.jpeg"
import prijieng1 from "../lastimages/product/prijieng1.jpeg"
import prijieng2 from "../lastimages/product/prijieng2.jpeg"
import cutomMainImage from "../lastimages/product/cutomMainImage.png"

export { tourDetailMain_bg, hotelPageMain, hotelDetail1, hotelDetail2, hotelDetail3,
         package1, package2, paris, cutomMainImage, prijieng, prijieng1, prijieng2 };

export default { tourDetailMain_bg, hotelPageMain, hotelDetail1, hotelDetail2, hotelDetail3,
        package1, package2, paris, cutomMainImage, prijieng, prijieng1, prijieng2
      };
